<template>
  <div class="nomination-review">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <template v-if="nominationCategory === 'On the Spot'">
          <ContentHeader name="On the Spot Downgrade"></ContentHeader>
        </template>
        <template v-else> 
          <ContentHeader name="Teams Downgrade"></ContentHeader>
        </template>
        <div class="pt-2 mb-3" v-if="this.nomination.isteamaward[0] !== undefined && this.nomination.isteamaward[0] == 'true'">
          <h5>Nominated Team Members:</h5>
          <ul>
            <li v-for="teams in nomination.nominationteam[0]" v-bind:key="teams.member_slug">
              <h6>
                <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
                <a href="/index.php?page_id=164">{{teams.member_name}}</a>
              </h6>
              <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Employee Number:</span> {{ teams.member_employee_number }}</h6>
              <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{teams.member_company}}</h6>
            </li>
          </ul>
        </div>
        <div class="pt-2 mb-3" v-else>
          <h5>Nominee Details:</h5>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="/index.php?page_id=164">{{nomination.nominee_name[0]}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Employee Number :</span> {{ nomination.nominee_employeeNumber[0] }}</h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominee_company[0]}}</h6>
          <!--h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> Date:</span> {{ nominationDate }}</h6-->
        </div>
        <hr>
        <div class="pt-2 mb-3">
          <h5> Nominator Details: </h5>
          <h6>
            <span class="text-black-50"><i class="fas fa-user fa-fw"></i> Name:</span>
            <a href="/index.php?page_id=164">{{nomination._embedded.author[0].name}}</a>
          </h6>
          <h6><span class="text-black-50"><i class="fas fa-building fa-fw"></i> Company:</span> {{nomination.nominator_details[0][0]['employee-company']}}</h6>
          <h6><span class="text-black-50"><i class="fas fa-globe fa-fw"></i> On:</span> {{ nominationDate }}</h6>
        </div>
        <hr>
        <div class="mb-3" v-html="nomination.content.rendered"></div>
        <router-link v-if="nomination.supporting_documentation.length !== 0" :to="'/supporting-documentation/' + nomination.supporting_documentation" target="_blank" class="btn btn-primary mb-3">View supporting documentation</router-link>
        <hr>
        <div v-if="!stageApprove && $route.params.hasOwnProperty('level')">
          <div v-if="showSubstationFields"></div>
          <div v-if="!showSubstationFields" role="alert" class="alert alert-success">{{acceptDeclineMsg}}</div>
        </div>
        <div v-if="stageApprove && !displayHM">
          <div role="alert" class="alert alert-success" v-if="stageStatus === 'Approved'">
            You have <strong>{{stageStatus}}</strong> the nomination.
          </div>
          <div role="alert" class="alert alert-danger" v-if="stageStatus === 'Rejected'">
            You have <strong>{{stageStatus}}</strong> the nomination.
          </div>
        </div>
        <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
          <div v-for="formField in nominationFields" v-bind:key="formField.index">
            <template v-if="formField.type === 'FieldHigh5Cards'">
                <!-- Handle high5 type -->
                <NominationField
                    :type="formField.type"
                    :description="formField.description"
                    :secondary-description="formField.secondaryDescription"
                    :description-lvl-two="formField.description_lvl_two"
                    :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                    :is-required="formField.isRequired"
                    :checkbox-labels="formField.checkboxLabels"
                    @updatedFieldContent="fieldUpdated"
                    :validationMethod="formField.validationMethod"
                    :displayField="formField.display_field"
                    :categoryBigcards="categoryBigcards"
                    :initialSelected="initialSelected"
                    :dataImages="dataImages"
                    :parentCategoryselected="parentCategoryselected"
                    :error-class="formField.errorClass">
                </NominationField>
              </template>
              <template v-else-if="formField.type === 'Field150Word'">
                  <!-- Handle Field150Word -->
                  <NominationField
                      :type="formField.type"
                      :description="formField.description"
                      :secondary-description="formField.secondaryDescription"
                      :description-lvl-two="formField.description_lvl_two"
                      :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                      :is-required="formField.isRequired"
                      :checkbox-labels="formField.checkboxLabels"
                      @updatedFieldContent="fieldUpdated"
                      :validationMethod="formField.validationMethod"
                      :displayField="formField.display_field"
                      :categoryNomination="categoryNomination"
                      :error-class="formField.errorClass"
                      :defaultText="nominatedComments">
                  </NominationField>
              </template>
              <template v-else>
                  <!-- Handle other types -->
                  <NominationField
                      :type="formField.type"
                      :description="formField.description"
                      :secondary-description="formField.secondaryDescription"
                      :description-lvl-two="formField.description_lvl_two"
                      :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                      :is-required="formField.isRequired"
                      :checkbox-labels="formField.checkboxLabels"
                      @updatedFieldContent="fieldUpdated"
                      :validationMethod="formField.validationMethod"
                      :displayField="formField.display_field"
                      :categoryNomination="categoryNomination"
                      :error-class="formField.errorClass">
                  </NominationField>
              </template>
          </div>
          <div class="row py-1">
            <div class="col offset-md-4 offset-lg-4 offset-xl-3">
              <div class="form-group form-check">
                <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                  <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                </label>
              </div>
            </div>
          </div>
          <div class="row pt-2 mb-4">
            <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
              <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import Field150Word from '@/components/Field150Word'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import PreContentHeader from '@/components/PreContentHeader'
import NominationField from '@/components/NominationFieldNew'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Field150Word,
    NominationField
  },
  computed: {
    ...mapGetters([
      'getProfileDetails'
    ])
  },
  data () {
    return {
      award: [],
      errors: [],
      contentLoadError: '',
      nominationContent: [],
      nominationFields: [],
      nominatedPerson: '',
      madeNomination: false,
      termsCheckbox: false,
      validatedNominee: '',
      showNominationForm: false,
      creatingNomination: false,
      createNominationError: '',
      searchingForEmployee: false,
      searchingForEmployeeError: '',
      isContractorErrorSet: true,
      isTeamAwards: false,
      submitClicked: true,
      NominationButtonText: 'Nominate',
      NominationLabel: 'Nominate an Employee for this Award',
      NominationPlaceholder: 'Search by name and surname or email address...',
      NominationTeamNames: [],
      NominationTeamsContent: [],
      nomineesList: [],
      employeeHierarchy: {},
      awardFields: [{name: 'individual', fields: 'FieldCheckBoxesBehaviours, Field150Word, FieldFileInput'}, {name: 'team', fields: 'FieldCheckBoxesBehaviours, Field150Word, FieldFileInput, FieldSingleText'}],
      localErrorClass: 'fjfsdfdskjfdsjlkfdsjkl', // Initialize the local error class
      contentReady: false,
      nominationDate: '',
      nomination: {},
      nominationCategory: '',
      categoryNomination: '',
      showSubstationFields: true,
      acceptDeclineMsg: '',
      nominatedComments: '',
      termsNotAccepted: false,
      nominationAccepted: false,
      nominationDeclineReason: '',
      stageStatus: '',
      validationErrMsg: '',
      stageApprove: false,
      workflowStages: [],
      workflowStagesLabel: [],
      nextStage: '',
      nextStageLabel: '',
      hierarchicalMessage: [],
      displayHM: true,
      categoryBigcards: [],
      behavioursChild:null,
      initialSelected: [],
      dataImages:[],
      parentCategory: [],
      childCategory: [],
      parentCategoryselected: [],
      modifiedContent: ''
    }
  },
  created () {
    this.loadContent()
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('nomination/' + this.$route.params.id + '?_embed')
      .then(response => {
        console.log('NominationReview', response.data)
        this.nomination = response.data
        console.log(' this.nomination.title.rendered ', this.nomination.title.rendered)
        if (this.nomination.title.rendered.includes('High5')) {
          alert('Current Nomination is already High5. Only On The Spot nomination can be downgraded')
          this.$router.push('/my-profile')
        }
        let splitData = this.exportContentData(this.nomination.nominationdata)
        console.log('getViewContent splitData ', splitData, splitData['Motivation'])
        if (splitData && splitData['Motivation']) {
          this.nominatedComments = splitData['Motivation']
        }
        if (response.data._embedded['wp:term'][2][1] && response.data._embedded['wp:term'][2][1].id > 114) {
          this.initialSelected = [
          {
            id: response.data._embedded['wp:term'][2][1].id,
            src: response.data._embedded['wp:term'][2][1].cover_image,
            alt: response.data._embedded['wp:term'][2][1].name
          }]
        } else if (response.data._embedded['wp:term'][2][0] && response.data._embedded['wp:term'][2][0].id > 114) {
          this.initialSelected = [
          {
            id: response.data._embedded['wp:term'][2][0].id,
            src: response.data._embedded['wp:term'][2][0].cover_image,
            alt: response.data._embedded['wp:term'][2][0].name
          }]
        }
        this.categoryBigcards = this.nomination.bigups_ecards
        this.getDate()
        if (this.nomination.isteamaward.includes('true')) {
          do {
            if (this.nomination.nominationteam[0].length === 1) {
              this.nomination.nominationteam[0] = this.nomination.nominationteam[0][0]
            }
          } while (this.nomination.nominationteam[0].length === 1)
        }
        this.nominationCategory = response.data._embedded['wp:term'][1].map(x => x.name).filter(x => x !== 'VE Awards').join()
        this.categoryNomination = this.nominationCategory
        if (this.nomination.bigups_ecards.length === 2) {
          for (var i = 0; i < this.nomination.bigups_ecards.length; i++) {
            if (this.nomination.bigups_ecards[i] > 106 && this.nomination.bigups_ecards[i] < 115) {
              this.parentCategory = this.nomination.bigups_ecards[i]
              this.parentCategoryselected = this.parentCategory
            }
            else {
              this.childCategory = this.nomination.bigups_ecards[i]
            }
          }
        }
        console.log(' 272 before  updateData is called ')
        this.updateData()
        console.log(' self.currentUserProfile ', self.currentUserProfile, self.setCurrentUser)
        this.contentReady = true
      })
      .catch(e => {
        this.childContentLoadError = 'Oops! We had a problem with loading your nomination. Please try again later.'
        console.error(e)
      })
  },
  methods: {
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/ /g, ' ').replace(/ /g, ' ').replace(/ /g, ' ')
          exportData[header] = value
        }
      })
      return exportData
    },
    fieldUpdated(fieldDetails) {
      // Handle the updated field content here
      // For example, you can log it or perform any necessary actions
      console.log('Field updated with content:', fieldDetails);
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].label === fieldDetails.label) {
          this.nominationContent[i].content = fieldDetails.content
          this.nominationContent[i].validated = fieldDetails.validated
          this.nominationContent[i].displayField = fieldDetails.displayField
          if (fieldDetails.label === 'Choose Behaviour') {
            this.nominationContent[i].parentcategory = fieldDetails.parentcategory
            this.nominationContent[i].parentName = fieldDetails.parentName
          }
          break
        }
      }
    },
    loadContent: function () {
      var tempData = '<a href="http://high5.multichoice.com" class="aquacolor font-weight-bold" target="_blank">Click here</a>'
      // var gettersData = this.$store.getters
      // console.log('this ref', this.$store.getters)
      // console.log('getEmail', this.$store.getters.getProfileDetails.email)
      // console.log('getEmail mapping', this.getProfileDetails)
      if (localStorage.getItem('high5Token')) {
        tempData = '<a href="http://high5.multichoice.com?mail_id=' + localStorage.getItem('high5Token') + '" class="aquacolor font-weight-bold" target="_blank">Click here</a>'
      } else if (this.$store.getters.getProfileDetails.email) {
        tempData = '<a href="http://high5.multichoice.com?mail_id=' + btoa(this.$store.getters.getProfileDetails.email.toLowerCase()) + '" class="aquacolor font-weight-bold" target="_blank">Click here</a>'
      }
      this.madeNomination = false
      this.nominatedPerson = ''
      // document.title = this.$route.params.name.replace(/-/g, ' ') + ' - ThinkTank'
      document.title = this.$route.name + ' - ThinkTank'
      // WordpressRestAPI.getViewContent('nomination_event?slug=' + this.$route.params.name + '&_embed')
      WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=22&_embed&per_page=1')
        .then(response => {
          this.award = response.data[0]
          this.award.content.rendered = this.award.content.rendered.replace('<microsite>LINK</microsite>', tempData)
          this.contentReady = true
          if (this.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            // this.isTeamAwards = false
            // this.NominationButtonText = 'Nominate'
            // this.NominationLabel = 'Nominate an Employee for this Award'
            // this.NominationPlaceholder = 'Search by name and surname or email address...'
            this.NominationTeamNames = []
            // if (this.award._embedded['wp:term'][1][0].id === 104 || this.award._embedded['wp:term'][0][0].id === 104 || this.award._embedded['wp:term'][0][0].id === 104 || this.award._embedded['wp:term'][0][1].id === 104) {
              this.isTeamAwards = true
              this.NominationButtonText = 'Add Nominee'
              this.NominationLabel = 'High5'
              this.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
            // }
            console.log(' this.award.nomination_fields[0][0] ', this.award.nomination_fields[0])
            console.log('loadContent this.award.nomination_fields[0][0] ', this.award.nomination_fields[0])
            for (let index = 0; index < this.award.nomination_fields[0][0].length; index++) {
              if (this.award.nomination_fields[0][0][index].form_field_type === 'DowngradeRejectionReason') {
                this.award.nomination_fields[0][0][index].field_description = 'Downgrade Reason'
                console.log('369 this.award.nomination_fields[0][0] ', this.award.nomination_fields[0][0][index])
                let temp = this.award.nomination_fields[0][0].splice(index,1)[0]
                this.award.nomination_fields[0][0].splice(1, 0, temp)
                // Remove the element at index 5 from this.award.nomination_fields[0][0] array
                break
              }
            }
            console.log('loadContent this.award.nomination_fields[0][0] ', this.award.nomination_fields[0])
            this.setNominationContent(this.award.nomination_fields[0][0])
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    setNominationContent: function (nominationFields) {
      var self = this
      console.log(' nominationFields ', nominationFields)
      self.nominationFields = nominationFields.map(function (x, index) {
        var displayFieldVal = x.display_field === "No" ? false : true
        var fieldDescriptionVal = x.field_description
        var FieldSecondaryDescriptionVal = x.field_secondary_description
        if (self.$refs.isMonetary) {
          if (self.$refs.isMonetary.checked) {
            var type = self.NominationTeamNames.length
            if (type == 1) {
              displayFieldVal = self.awardFields[0].fields.includes(x.form_field_type)
            }
            else if (type > 1) {
              displayFieldVal = self.awardFields[1].fields.includes(x.form_field_type)
            }
          }
          //Toggle Message/Motivation
          if (fieldDescriptionVal == "Message" && FieldSecondaryDescriptionVal == "Motivation") {
            if (self.$refs.isMonetary.checked) {
              fieldDescriptionVal = FieldSecondaryDescriptionVal
            }
            FieldSecondaryDescriptionVal = ''
          }
        }
        if (x.form_field_type === 'Field150Word') {
          fieldDescriptionVal = "Message to reflect on High 5 sent to employee"
        }
        return {
          type: x.form_field_type,
          description: fieldDescriptionVal,
          secondaryDescription: FieldSecondaryDescriptionVal,
          isRequired: x.required_nomination_field,
          checkboxLabels: x.checkbox_labels,
          errorClass: '',
          index: index + x.form_field_type,
          description_lvl_two: x.description_lvl_two,
          secondary_description_lvl_two: x.secondary_description_lvl_two,
          display_field: displayFieldVal,
          validationMethod: x.validationmethod
        }
      })
      console.log(' self.nominationContent ', self.nominationContent)
      if (self.nominationContent.length > 1) {
        self.nominationContent = self.nominationFields.map(function (x, i) {
          return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
        })
      } else  {
        self.nominationContent = self.nominationFields.map(function (x) {
          return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
        })
      }
    },

    submitNomination: function () {
      //this.submitClicked = false
      if (this.readyToSubmitNomination()) {
        this.createNominationEntry()
      } else {
        this.submitClicked = true
      }
    },
    readyToSubmitNomination: function () {
      var contentPassedValidation = true
      this.searchingForEmployeeError = ''
      console.log(' nominationContent ', this.nominationContent)
      for (var j = 0; j < this.nominationContent.length; j++) {
        console.log(' this.nominationFields[j].display_field ',this.nominationFields[j],  this.nominationFields[j].display_field)
        this.nominationFields[j].errorClass = ''
        if (this.nominationFields[j].display_field === false) {
          continue
        } else {
          if (this.nominationFields[j].validationMethod) {
            contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
            
          }
          if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
            this.nominationContent[j].validated = true
          }
          if (this.nominationContent[j].validated === false) {
            contentPassedValidation = false
            this.nominationFields[j].errorClass = 'field-not-validated'
            
          }
          if (this.isTeamAwards) {
            if (this.NominationTeamNames.length > 50) {
              this.searchingForEmployeeError = 'Team Member count can\'t exceeds 50!'
              contentPassedValidation = false
            }
          }
          // Stop immedieatly any field validation is false
          if (contentPassedValidation === false)
            break;
        }
      }
      return this.termsCheckbox && contentPassedValidation
    },

    generateSearchQuery: function (sendNomination) {

      let string = '?bigups_ecards=' + sendNomination.bigups_ecards+'&id='+sendNomination.id+'&nomination_event_category='+sendNomination.nomination_event_category
      string = string+'&community_categories='+sendNomination.community_categories

      var modifiedString = ''
      var inputString = this.nomination.title.rendered;
      var resultArray = inputString.split(',');

      if (resultArray[0].trim() === "Team Awards") {
        resultArray[0] = "Team High5";
      } else if (resultArray[1].trim() === 'On the Spot') {
        resultArray[1] = 'High5'
      }

      modifiedString = resultArray.join(',');

      string = string+'&post_title='+modifiedString+'&guid='+this.nomination.guid.rendered+'&slug='+this.nomination.slug
      //string = string+'&content='+sendNomination.content
      string = string+'&rejection_reason='+this.getRejectionReason()
      string = string+'&content='+this.setPostContent('text')
      let user = ''
      console.log('generateSearchQuery this.nomination.teamnominationworkflow[0].length ', this.nomination.teamnominationworkflow[0].length)
      if (this.nomination.teamnominationworkflow[0].length === 4 ) {
        console.log('generateSearchQuery 487  ')
        let name = this.nomination.teamnominationworkflow[0][3]
        if (name.project_sponsor_status.toLowerCase() === "") {
          user = name.project_sponsor_name
          console.log(' generateSearchQuery 491 ', user, name.project_sponsor_name)
        }
      }
      if (user === '') {
        for (let i = 0; i < this.nomination.teamnominationworkflow[0].length; i++) {
          let name = this.nomination.teamnominationworkflow[0][i]
          if (name.project_sponsor_status.toLowerCase() === "") {
            user = name.project_sponsor_name
            break; // Exit the loop after the first match
          }
        }
      }
	  if (user) {
        string= string+'&downgrade_user='+user
      }
      console.log('generateSearchQuery string ', string)
      return string
    },

    createNominationEntry: function () {
      var self = this
      var sendNomination = {
        method: 'POST',
        data: {
          title: self.getNominationTitle(),
          nomination_event_category: self.getNominationEventCategory(),
          community_categories: self.assignUserCommunities(),
          nomination_approve_decline: 'Accepted',
          nominee_name: self.validatedNominee.name,
          nominee_slug: self.validatedNominee.slug,
          status: 'publish',
          content: self.setPostContent('html'),
          nominationdata: self.setPostContent('nohtml'),
          nominator_details: [{
            'employee-number': self.validatedNominee.employeeNum,
            'employee-company': self.validatedNominee.department
          }]
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      var parentName = ''
      sendNomination.data.bigups_ecards = []
      sendNomination.data.bigups_ecards.push(self.nominationContent.filter(x => {return x.label.indexOf('Choose Behaviour') > -1 })[0].parentcategory)
      sendNomination.data.bigups_ecards.push(self.nominationContent.filter(x => {return x.label.indexOf('Choose Behaviour') > -1 })[0].content)
      parentName = self.nominationContent.filter(x => {return x.label.indexOf('Choose Behaviour') > -1 })[0].parentName
      sendNomination.data.id = this.$route.params.id
      console.log(' sendNomination ', sendNomination)
      let str = this.generateSearchQuery(sendNomination.data)
      console.log(' string ', str)
      WordpressRestAPI.getCustomViewContent('getNomination/v1/downgradeNomination'+this.generateSearchQuery(sendNomination.data))
      .then(response => {
          console.log('review list-> ', response.data, response.data.update)
          if (response.data !== false) {
            if (response.data.update) {
              this.high5Notification(this.nomination, parentName)
              this.$router.push('/my-profile')
              console.log('entry added')
            }
          }
          else {
            console.log('There was error when downgrading nomination', response.data)
          }
      })
      .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with downgrading your On the spot nominations. Please try again later.'
          console.error(e)
      })
    },
    high5Notification: function (nominationDetails, parentName) {
      let emailBody = ''
      var tempEmail = []
      var toMail, ccMail, nomineeName = ''
      this.NominationTeamNames = this.nomination.nominationteam[0]
      if (this.nomination.id) {
        this.NominationTeamNames = this.nomination.nominationteam[0]
        if (this.nomination.isteamaward !== undefined && this.nomination.isteamaward[0] === 'true') {
          console.log(' this.NominationTeamNames this.NominationTeamNames[0]', this.NominationTeamNames)
          let toMailChunks = this.NominationTeamNames.map(function (name, index) {
            return name.member_email
          })
          console.log('this.NominationTeamNames toMailChunks ', toMailChunks)
          toMail = toMailChunks.join(',')
          console.log(' this.NominationTeamNames toMail ', toMail)
          let toNameChunks = this.NominationTeamNames.map(function (name, index) {
            //return name.member_name.split(' ')[0]
            return name.member_name
          })
          console.log(' this.NominationTeamNames toNameChunks ', toNameChunks)
          nomineeName = toNameChunks.join(',')
          console.log(' this.NominationTeamNames nomineeName ', nomineeName)
        } else {
          // Handle the case where isteamaward is not true or its first element is not 'true'
        nomineeName = this.nomination.nominee_name[0]
        toMail = this.nomination.nominee_slug[1]
        console.log('this.NominationTeamNames nominationteam nomineeName', this.nomination.nominee_name[0])
        console.log('this.NominationTeamNames nominationteam  toMail = ', this.nomination.nominee_slug[1])
      }
      let ccMailChunks = this.nomination.teamnominationworkflow[0].map(function (name, index) {
          return name.project_sponsor_email
      })
      ccMail = ccMailChunks.join(',')
      console.log('this.NominationTeamNames ccMail ', ccMail)
      console.log('this.NominationTeamNames nomineeName ', nomineeName)
      emailBody = NominationNotification.high5Notification({
          nominee: nomineeName,
          nominator: this.nomination._embedded.author[0].name,
          cardName: parentName
      })
      console.log('this.NominationTeamNames emailBody ', emailBody)
      console.log('high5Notification nominee ', nomineeName)
      console.log('high5Notification parentName ', parentName)
      console.log('high5Notification nominator ', this.nomination._embedded.author[0])
      console.log('high5Notification toMail ', toMail)
      console.log('high5Notification message ', emailBody)
      console.log('high5Notification attachmentId ', nominationDetails.id)
      console.log('high5Notification recipient ', nomineeName)
      console.log('high5Notification nominationCategory ', this.nominationCategory)
      var nominatorEmail = this.nomination._embedded.author[0].user_email
        // tempEmail = nominationDetails.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === reviewer)
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: toMail,
            subject: "You've received a High 5!",
            message: emailBody,
            cc: ccMail,
            attachmentId: nominationDetails.id,
            recipient: nomineeName,
          },
          json: true
        }
        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
        })
        emailBody = NominationNotification.downgradeNotification({
          nominee: nomineeName,
          nominator: this.nomination._embedded.author[0].name,
          cardName: parentName,
          category: this.nominationCategory,
          motivationMessage: this.setPostContent('text'),
          rejectionReason: this.getRejectionReason()
        })
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: nominatorEmail,
            subject: "Your Nomination for user "+toMail+" is downgraded to High5",
            message: emailBody,
            cc: ccMail,
            attachmentId: nominationDetails.id,
            recipient: nomineeName,
          },
          json: true
        }
        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
        })
      }
    },
    getDate: function() {
      let d = this.nomination.date.split('T')
      let options = {year: "numeric", month: "short", day: "numeric"};
      this.nominationDate = new Intl.DateTimeFormat('en-US', options).format(new Date(d[0]))
    },
    nthDate: function(d) {
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },  
    populateFieldInput: function (content) {
      if (content.label === 'Add comments:') {
        this.nominatedComments = content.content
      }
    },
    getNominationTitle: function () {
      var self = this
      var nominationTitle = ''
      if (self.NominationTeamNames.length === 1) 
          nominationTitle = self.validatedNominee.name + ', High5'
        else
          nominationTitle = 'Team High5, by ' + this.nomination._embedded.author[0].name
      return nominationTitle
    },
    getNominationEventCategory: function () {
      var self = this
      var nominationEventCategory = []
      nominationEventCategory.push('20')
      nominationEventCategory.push('102')
      return nominationEventCategory
    },
    assignUserCommunities: function () {
      const userCommunityIDstring = this.$store.getters.getUserCommunityIDstring;
      if (userCommunityIDstring) {
        return this.award.community_categories.filter(
          f => userCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
        );
      } else {
        return [] // Return an empty array if userCommunityIDstring is undefined or empty
      }
    },
    setPostContent: function (type) {
      var content = ''
      var plainContent = ''
      var text= ''
      for (var i = 0; i < this.nominationContent.length; i++) {
        console.log(' this.nominationContent[i] ', this.nominationContent[i])
        if (this.nominationContent[i].displayField)
          if (this.nominationContent[i].label !== 'If applicable, please attach supporting documentation (Word, PowerPoint, video):' && this.nominationContent[i].label !== 'Project Sponsor Email' && this.nominationContent[i].label !== 'Choose Behaviour' && this.nominationContent[i].label !== 'Downgrade Reason') {
            content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
            plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
            text = this.nominationContent[i].content  
            console.log(' this.nominationContent[i] 654', this.nominationContent[i], text)
          }
      }
      console.log(' text ', text, ' type ', type)
      if (type=== 'text') {
        return text
      }
      return (type === 'nohtml' ? plainContent : content)
    },
    getRejectionReason: function () {
      for (var i = 0; i < this.nominationContent.length; i++) {
        console.log('getRejectionReason this.nominationContent[i] ', this.nominationContent[i])
        if (this.nominationContent[i].displayField)
          if (this.nominationContent[i].label === 'Downgrade Reason') {
            return this.nominationContent[i].content
          }
      }
      return false
    },
    updateData: function () {
      var self = this
      console.log('NominationReview 720 self.nomination.isteamaward ', self.nomination.isteamaward)
      console.log('NominationReview 720  employeehierarchy?slug=' + self.nomination.nominee_slug[0]+ '&_embed')
      if (self.nomination.isteamaward !== undefined && self.nomination.isteamaward[0] !== undefined && self.nomination.isteamaward[0] === "true") {
        self.nomination.nominationteam[0].forEach((member, index) => {
          if (!member.member_company || !member.member_employee_number) {
            console.log('team member_company ', member.member_company, 'team member_employeenumber ', member.member_employee_number, index, member.member_name);
            ADauthentication.getUserInfoByEmail(member.member_email)
              .then(response => {
                console.log('after team authentication');
                console.log('749 response.data i ', index, self.nomination.nominationteam[0]);
                console.log('749 response.data ', response.data.company);
                console.log('749 response.data ', response.data.employeenumber);
                if (!member.member_company) {
                  self.nomination.nominationteam[0][index].member_company = response.data.company;
                  console.log(' NominationReview 736 ', member.member_company);
                }
                if (!member.member_employee_number) {
                  self.nomination.nominationteam[0][index].member_employee_number = response.data.employeenumber;
                  console.log(' NominationReview 736 ', member.member_employee_number);
                }
                console.log('set validate nominee');
              })
              .catch(e => {
                console.error(e);
              });
          }
        });
      } else {
        ADauthentication.getUserInfoByEmail(self.nomination.nominee_slug[1])
        .then(response => {
          console.log('749 response.data ', response.data.company)
          console.log('749 response.data ', response.data.employeenumber)
          if (!self.nomination.nominee_employeeNumber[0]) {
            self.$set(self.nomination.nominee_employeeNumber, 0, response.data.employeenumber);
            console.log('after NominationReview nominee_employeeNumber empty ', self.nomination.nominee_employeeNumber[0]);
          }
          if (!self.nomination.nominee_company[0]) {
            self.$set(self.nomination.nominee_company, 0, response.data.company);
            console.log(' NominationReview nominee_company empty ', self.nomination.nominee_company[0]);
          }
        })
        .catch(e => {
          console.error(e)
        })
      }
      /*if (!self.nomination.nominator_details[0][0]['employee-company']) {
        console.log('before calling nominator')
        ADauthentication.getUserInfoByEmail(self.nomination._embedded.author[0].user_email)
        .then(response => {
          alert('after authentication')
          console.log('749 response.data ', response.data.company)
          console.log('749 response.data ', response.data.employeenumber)
          if (!self.nomination.nominee_employeeNumber[0]) {
            self.nomination.nominator_details[0][0]['employee-company'] = response.data.company
            console.log('after NominationReview nominee_employeeNumber empty ', self.nomination.nominee_employeeNumber[0])
          }
        })
        .catch(e => {
          console.error(e)
        })      
      }*/
    }
  },
  watch: {
    immediate: true,
    deep: true,
    getProfileDetails (newDetails, oldDetails) {
    },
    termsCheckbox (newValue, oldValue) {
      // This function will be called when termsCheckbox changes
      console.log('termsCheckbox changed:', newValue, this.termsCheckbox)

      // You can perform actions based on the new value or old value
      if (newValue) {
        // The checkbox is checked
        // Perform actions when checked
      } else {
        // The checkbox is unchecked
        // Perform actions when unchecked
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/nd.vue